import { SelectList, TextBox } from '@/components/formFields/common';
import {
  email as vEmail, maxLength, phone as vPhone, required
} from '@/validators';
import { omit } from '@/helpers/util';

export const firstName = {
  label: 'First Name',
  componentType: TextBox,
  class: 'col-md-6',
  rules: { required, maxLength: maxLength(20) }
};

export const lastName = {
  ...firstName,
  label: 'Last Name'
};

export const organization = {
  label: 'Organization',
  componentType: TextBox,
  class: 'col-md-12',
  rules: { maxLength: maxLength(40) }
};

export const address1 = {
  label: 'Address Line 1',
  componentType: TextBox,
  class: 'col-md-6',
  rules: { required, maxLength: maxLength(50) }
};

export const address2 = {
  ...address1,
  label: 'Address Line 2',
  rules: omit(address1.rules, ['required'])
};

export const city = {
  label: 'City',
  componentType: TextBox,
  class: 'col-md-6',
  rules: { required, maxLength: maxLength(30) }
};

export const state = {
  label: 'State',
  componentType: SelectList,
  options: ['AF', 'AK', 'AL', 'AR', 'AS', 'AU', 'AZ', 'CA', 'CE', 'CN', 'CO', 'CT', 'DC', 'DE', 'EU', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'MX', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SA', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'],
  includeEmpty: false,
  class: 'col-md-2',
  rules: { required }
};

export const zip = {
  label: 'Zip Code',
  componentType: TextBox,
  class: 'col-md-4',
  rules: {
    maxLength: maxLength(10),
    required
  }
};

export const email = {
  label: 'E-mail',
  componentType: TextBox,
  class: 'col-md-6',
  rules: {
    email: vEmail,
    maxLength: maxLength(49),
    required
  }
};

export const phone = {
  label: 'Phone Number',
  componentType: TextBox,
  class: 'col-md-6',
  rules: {
    phone: vPhone,
    required
  },
  mask: '(999) 999-9999'
};

export const fax = {
  label: 'Fax Number',
  componentType: TextBox,
  class: 'col-md-6',
  rules: {
    phone: vPhone
  },
  mask: '(999) 999-9999'
};
